var map = {
	"./amjs/animation1.png": "4e33",
	"./amjs/animation2.png": "56f4",
	"./amjs/app1.png": "e3f9",
	"./amjs/logo.png": "8c42",
	"./amjs/logo1.png": "68dc",
	"./gtg/animation1.png": "c72e",
	"./gtg/animation2.png": "783a",
	"./gtg/app1.png": "f520",
	"./gtg/logo.png": "8e90",
	"./gtg/logo1.png": "3e62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b0f";